module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAABNElEQVQ4T2NkoDJgpLJ5DMPAwFWrVnF+/f71MQMDgzBS8BQnxif2YQsunF5uaGhgkleUv8XAwKCMM5wZGaIT4xKXIctjNXD+wvknGBgYzImNMCYGJqf4+Pj9IPUoBs5cNlOE7Tfba2INQlN3NzE+UQXFwAWLFkz7//9/JpkGMiTGJzKiGDh/4fz/cMP+MTgyMDNoMPxnmI7DgqcP5R4qyD+S/w2Tx28gSNU/BsvExMQT8xfOb2BgYKiHavz0jfObdHZY9pd5C+ftY2RgdCTeQIjK/3+Z/qqlxKbcWbx4sWRsbOzz+YvmL2H4zxCN7nLCLkTS8Z/h//mk+CQjlGBBM5EkAxkYGC4mxicaDLiBb9CyGLKnSHchgYR9MzE+UQOPlzETNsw5VMt6yP6jauGAbDCpxRcAnKqRFT1LwyMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/about-c_icon_hy_nor.png
// module id = nfho
// module chunks = 1